<template>
    <section class="container">
        <h3>Despues de la Reparación</h3>
        <div class="row">
            <div class="col-md-6 col-12">
                <div class="alert alert-outline-primary fade show" role="alert">
                    <div class="alert-icon"><i class="la la-info-circle"></i></div>
                    <div class="alert-text"><b>{{calculo(paso1.datos.elements[0],paso1.datos.elements[1])}}</b> día(s) para la entrega</div>
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="alert alert-outline-primary fade show" role="alert">
                    <div class="alert-icon"><i class="la la-barcode"></i></div>
                    <div class="alert-text"><b>#{{paso1.datos.dt1}}</b> {{paso1.agencia.empresa}} {{paso1.agencia.detalles}}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 col-3">
                <div>
                    <div class="kt-portlet kt-portlet--solid-seconday">
                        <div class="kt-portlet__head">
                            <div class="kt-portlet__head-label">
                                <h3 class="kt-portlet__head-title"><i class="fa fa-info-circle"></i> Datos generales</h3>
                            </div>
                        </div>
                        <div class="kt-portlet__body sin-p">
                            <div class="kt-widget1">
                                <div class="kt-widget1__item">
                                    <div class="kt-widget1__info">
                                        <h3 class="kt-widget1__title">Marca</h3>
                                        <span class="kt-widget1__desc">{{paso1.datos.dt7}}</span>
                                    </div>
                                </div>
                                <div class="kt-widget1__item">
                                    <div class="kt-widget1__info">
                                        <h3 class="kt-widget1__title">Modelo</h3>
                                        <span class="kt-widget1__desc">{{paso1.datos.dt6}}</span>
                                    </div>
                                </div>
                                <div class="kt-widget1__item">
                                    <div class="kt-widget1__info">
                                        <h3 class="kt-widget1__title">Cliente</h3>
                                        <span class="kt-widget1__desc">{{paso1.datos.dt4}}</span>
                                    </div>
                                </div>
                                <div class="kt-widget1__item" v-if="paso1.datos.dt8">
                                    <div class="kt-widget1__info">
                                        <h3 class="kt-widget1__title">Aseguradora</h3>
                                        <span class="kt-widget1__desc">{{paso1.datos.dt8}}</span>
                                    </div>
                                </div>
                                <div class="kt-widget1__item">
                                    <div class="kt-widget1__info">
                                        <h3 class="kt-widget1__title">Observación</h3>
                                        <span class="kt-widget1__desc">{{paso1.datos.dt3}}</span>
                                    </div>
                                </div>
                                <div class="kt-widget1__item">
                                    <div class="kt-widget1__info">
                                        <h3 class="kt-widget1__title">Fecha de recepción</h3>
                                        <span class="kt-widget1__desc">{{formatoFecha(paso1.datos.elements[0])}}</span>
                                    </div>
                                </div>
                                <div class="kt-widget1__item">
                                    <div class="kt-widget1__info">
                                        <h3 class="kt-widget1__title">Fecha de entrega</h3>
                                        <span class="kt-widget1__desc">{{formatoFecha(paso1.datos.elements[1])}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <carusel :lista="paso1.datos.elements3"></carusel>
        </div>
        <div class="row p-3 d-flex justify-content-between">
            <button type="button" class="btn btn-lg btn-secondary btn-font-sm" v-on:click="atras"><i class="flaticon2-back"></i> Regresar</button>
<!--            <button type="button" class="btn btn-lg btn-primary btn-font-sm" v-on:click="siguiente" > Continuar <i class="flaticon2-next"></i></button>-->
        </div>
    </section>
</template>
<script>
    import carusel from "../componentes/carusel";
    export default {
        name: "paso-3",
        data:()=>({
            formulario:{
                mapaeleige: null,
            },
            currentId:null,
            ventana:null,
            imagenes:[],
        }),
        components:{
            carusel
        },
        computed:{
            paso1:function(){
                return this.$store.getters.getPasos[1];
            },
            fotos:function(){
                let vector=[];
                this.$store.getters.getPasos[1].datos.elements2.map(item=>{
                    vector.push({src:process.env.VUE_APP_URL_API+item.dt4,id:item.hsh1,thumbnail:process.env.VUE_APP_URL_API+item.dt4})
                });
                return vector;
            }
        },
        methods:{
            formatoFecha:function(fecha){
                return fecha ? this.$moment(fecha.ddt1, "YYYY-MM-DDTHH:mm:ss").format("ddd DD MMM YYYY") : null;
            },
            siguiente:function(){
                this.$store.commit('setActual', 3);
                this.$router.push({ name: 'p3' });
            },
            calculo:function(fechai,fechaf){
                if(fechai && fechaf){
                    let a   =   this.$moment(fechai.ddt1, "YYYY-MM-DDTHH:mm:ss");
                    let b   =   this.$moment(fechaf.ddt1, "YYYY-MM-DDTHH:mm:ss");
                    return b.diff(a, 'days')>=0 ? b.diff(a, 'days') : 0;
                }else{
                    return null;
                }
            },
            atras:function(){
                this.$store.commit('setActual', 2);
                this.$router.push({ name: 'p2' });
            },
        },
        created() {
            this.$store.commit('setActual', 3);
        }
    }
</script>
<style scoped>
    .btn-elevate{
        display:block;
    }
    .sin-p{
        padding: 0px !important;
    }
</style>
